import {TAppStore} from 'core/redux/types';

/**
 * Класс синглтон для хранения серверного редакс-стора
 */
export class ReduxService {
    public static serverReduxStore: TAppStore;
    public static clientReduxStore: TAppStore;
}
